export default __webpack_public_path__ + "99ebb405b8cf3d3785b0210cd5b82720.png";